// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".space-configurations[data-v-49fe0df0]{padding-bottom:46px}.space-configurations h1[data-v-49fe0df0]{margin-bottom:20px;font-family:\"Instrument Serif\",Georgia,Times New Roman,serif;font-style:normal;font-weight:400;font-size:28px;line-height:38px}.space-configurations-form .form-input[data-v-49fe0df0]{margin-bottom:28px}.space-configurations-form .form-input[data-v-49fe0df0]  .error-message{font-size:16px!important}", ""]);
// Exports
module.exports = exports;
